import type { ReactNode } from 'react';
import type { Permission } from '@blesk/contracts';
import { useHasPermission } from '../../shared/session';

/**
 * §3 ТЗ. Экран, закрытый правом.
 *
 * Пункт меню скрыт, но прямая ссылка на раздел существует всегда — поэтому
 * право проверяется ещё и здесь. Это удобство для человека, а не защита:
 * данные всё равно не придут, сервер откажет сам.
 */
export function PermissionGate({
  permission,
  children,
}: {
  permission: Permission;
  children: ReactNode;
}) {
  if (!useHasPermission(permission)) {
    return (
      <section className="notice">
        <h1>Недостаточно прав</h1>
        <p>
          Раздел доступен другим ролям. Если доступ нужен по работе — обратитесь к системному
          администратору.
        </p>
      </section>
    );
  }
  return <>{children}</>;
}
